import { FetchExperimentsRequestTypes } from '../actions/ExperimentationActions';
const INITIAL_STATE = {
  treatments: {}
};
const Experimentation = (state = INITIAL_STATE, {
  type,
  payload
}) => {
  switch (type) {
    case FetchExperimentsRequestTypes.RECEIVE:
      {
        return {
          treatments: payload
        };
      }
    default:
      return state;
  }
};
export default Experimentation;